<template>

  <div class="body">
    <!-- 头部图 -->
    <div class="first-box" style="position: relative" id="topBox">
      <div class="first-title">
        <span>不止于系统集成</span>
        <span>更致力于构建您的一体化数字商业引擎</span>
        <p>
          以客户业务价值为牵引，以数据中台为基石，解决您的核心诉求
        </p>
      </div>
      <div class="pic" style="">
        <div class="first-pictop">
            <div class="topCard-box">
          <div class="topCard">
            <div class="topCardIcon">
              <img src="@/assets/icons/全流程交付与上线实施.png" alt="" style="height: 30px"/>
              <h3>全流程交付与上线实施</h3>
            </div>
            <div class="topCardText">基于业务需求专业团队全程陪跑执行</div>
          </div>
          <div class="topCard">
            <div class="topCardIcon">
              <img src="@/assets/icons/全方位安全保障.png" alt="" style="height: 30px"   />
              <h3>全方位安全保障</h3>
            </div>
            <div class="topCardText">加密合规需求，保护云上数据安全</div>
          </div>
          <div class="topCard">
            <div class="topCardIcon">
              <img
                src="@/assets/icons/全维数字经营驱动.png"
                alt=""
                style="height: 30px"
              />
              <h3>全维数字经营驱动</h3>
            </div>
            <div class="topCardText">数字洞察力，效果为导向精准营销获客</div>
          </div>
          <div class="topCard">
            <div class="topCardIcon">
              <img
                src="@/assets/icons/全天品质服务.png"
                alt=""
                style="height: 30px"
              />
              <h3>全天品质服务</h3>
            </div>
            <div class="topCardText">7×24小时专业工程师团队支持</div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="last-box">
    <div class="second-box">
      <p>全渠道信息化建设，驱动全链路价值增长</p>
      <img src="@/assets/bg/全渠道信息化建设.png" alt="" />
    </div>
     <div class="third-box" id="products1">
        <div class="third-title">
            聚焦业务场景，总有一款方案满足您的业务期盼
        </div>
        <div class="third-content">
            <div class="content-top">
                <div class="top-icon"></div>
                <span class="top-title">样衣生命周期管理</span>
                <div class="content-text"><p>一套专门用于对开发、生产完的样衣进行精细化、数字化管理的解决方案</p></div>
            </div>
            <div class="content-detail">
                <div class="detail">
                    <div class="detail-item">
                        <div class="detail-icon"></div>
                        <div class="detail-title">保护资产</div>
                    </div>
                    <div class="content-text">
                        品牌设计理念和工艺技术的结晶，清晰记录样衣档案数据，形成样衣数据资产,<br>进行样衣生命周期数字化管理
                    </div>
                </div>
                <div class="detail">
                    <div class="detail-item">
                        <div class="detail-icon"></div>
                        <div class="detail-title">促进协同</div>
                    </div>
                    <div class="content-text">
                        清晰的样衣状态(如出入库、库存状态、库龄、外借、清样等)让相关部门(设计、<br>商品、市场等)信息同步，减少沟通成本和决策延误。
                    </div>
                </div>
                <div class="detail">
                    <div class="detail-item">
                        <div class="detail-icon"></div>
                        <div class="detail-title">提升效率</div>
                    </div>
                    <div class="content-text">
                        样衣吊牌管理，方便样衣出入库及样衣盘点快速准确地定位样衣库存位置,<br> 完整外购样衣报销记录，避免重复审核报销
                    </div>
                </div>
                <div class="detail">
                    <div class="detail-item">
                        <div class="detail-icon"></div>
                        <div class="detail-title">降低成本</div>
                    </div>
                    <div class="content-text">
                        有效管理防止其丢失、损坏或被盗;减少因样衣丢失而导致的重复打样成本。
                    </div>
                </div>
            </div>

        </div>
      
    </div>
    <div class="four-box" id="products2">
        <div class="four-top">
            <div class="top-icon"></div>
            <div class="top-title">培训考试平台</div>
            <p>以“学考培管一体”为核心，帮企业高效落地培训、验证效果并降低管理成本</p>
        </div>
        <div class="four-content">
            <div class="content-item">
                <img src="@/assets/icons/学.png" >
                <h3>学</h3>
                <p>支持异地、随时学习考试，适配企业规模化或分布式团队需求</p>
            </div>
            <div class="content-item">
                <img src="@/assets/icons/培.png" >
                <h3>培</h3>
                <p>上传、分发、更新培训内容，支持多格式文件，形成企业课程知识库。</p>
            </div>
            <div class="content-item">
                <img src="@/assets/icons/考.png" >
                <h3>考</h3>
                <p>自动组卷、防作弊答题、智能阅卷,快速生成成绩报告。</p>
            </div>
            <div class="content-item">
                <img src="@/assets/icons/管.png" >
                <h3>管</h3>
                <p>追踪学员学习进度、考试通过率，形成培训效果分析。</p>
            </div>
        </div>
    </div>
    <div class="five-box" id="products3">
        <div class="five-top">
            <div class="top-icon"></div>
            <div class="top-title">企业快递助手</div>
            <p>将原本零散、低效、成本不透明的快递收发业务转变为一个高效、可控、数据驱动的标准化快递服务平台</p>
        </div>
        <div class="five-content">
            <el-row>
                <el-col :span="8">
                    <div class="content-item">
                        <div class="img"><img src="@/assets/icons/聚合议价.png" /></div>
                        <div class="content-right">
                            <div class="content-title">聚合议价，降低单票运费</div>
                            <p>整合全公司的寄件需求，形成规模效应，从而与快递公司谈判获得更优惠的企业协议价，直接降低每单快递的运费。</p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="content-item">
                        <div class="img"><img src="@/assets/icons/智能比价.png" /></div>
                        <div class="content-right">
                            <div class="content-title">智能比价，优选性价比渠道</div>
                            <p>系统可根据目的地、重量等要求，自动对比不同快递公司的价格。企业员工在寄件时可直观选择最经济的渠道，避免"习惯性”选择高价快递。</p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="content-item">
                        <div class="img"><img src="@/assets/icons/全流程管理.png" /></div>
                        <div class="content-right">
                            <div class="content-title">全流程管理与透明化追踪</div>
                            <p>通过权限控制流程，确保快递仅用于公务。管理者可在后台实时查看公司包惠的状态。</p>
                        </div>
                    </div>
                </el-col>
                
            </el-row>
            <el-row>
                <el-col :span="8">
                    <div class="content-item">
                        <div class="img"><img src="@/assets/icons/数据驱动.png" /></div>
                        <div class="content-right">
                            <div class="content-title">数据驱动决策与优化</div>
                            <p>多维度数据报表与分析，精准部门成本核算和优化快递策略。</p>
                            <ul>
                                <li>成本管控: 各部门/项目快递费用支出详情。</li>
                                <li>快递渠道: 各快递公司的使用量、费用对比。</li>
                            </ul>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
     <div class="six-box" id="products4">
      <div class="six-container">
        <h2 class="six-title">选择泽润，选择一份保障</h2>
        <div class="six-features">
          <!-- 第一行 -->
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/丰富的行业经验.png" />
            </div>
            <h3>丰富的行业经验</h3>
            <p>
              多年研发经验，横跨不同行业类目，真实案例累计支撑，成熟的解决方案，交付有保障。
            </p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/强大的研发能力.png" />
            </div>
            <h3>强大的研发能力</h3>
            <p>
              专业的研发团队，互联网大厂经验，协作流畅，深耕微信生态，拥有多年专业的产品研发积累。
            </p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/高度的定制服务.png" />
            </div>
            <h3>高度的定制服务</h3>
            <p>深度商业模式分析，用户研究，运营现场调研，为客户量身定制。</p>
          </div>
          <!-- 第二行 -->
          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/更快的交付.png" />
            </div>
            <h3>更快的交付</h3>
            <p>
              完善的项目管理体系，成熟的管理团队，只为项目保质保量如期交付。
            </p>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/专业的售后.png" />
            </div>
            <h3>专业的售后</h3>
            <p>
              专业客服7*24小时在线，多维度、多渠道技术支持，多对一技术指导。
            </p>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <img src="@/assets/icons/更多的服务.png" />
            </div>
            <h3>更多的服务</h3>
            <p>
              一站式延展服务，涵盖运营培训，上线维护，软著申请营销推广，让你全程无忧。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="seven-box">
      <div class="seven-bottom">
        <h3>突破增长瓶颈，让数据流动起来，开启云上增长新空间！</h3>
        <p>
          泽润团队特别希望与您交流，分享给您我们是如何帮助行业头部市场拉动增长的
        </p>
      </div>
    </div>
   </div>

    <BottomFooter />
  </div>
  
</template>

<script>
import BottomFooter from './bottom.vue'

export default {
  name: "Service",
  components: {
    BottomFooter
  },
  props: {
    point: {
      type:String,
      default:''
    }
  },
  data () {
    return {
      isActive: true,
  }
  },
  watch: {
    point: {
        handler(newVal) {
          if(newVal){
            this.getScoll(newVal)
                console.log('新新新',newVal);
            }
        },
        immediate: true
    }
  },
  mounted () {
  },

  methods: {
    // 滚动
    getScoll(point){
      this.$nextTick(() => {
        // 元素自身高度
        const height = document.getElementById(point).offsetHeight
        const scrollTop = (document.getElementById(point).offsetTop)-(height/2) // 获取需要滚动的距离
        document.documentElement.scrollTop = scrollTop 
      })
    }
    },
   
};
</script>

<style lang="less" scoped>
    .body{background-color: #000;font-family: 'PingFang SC !important';}
    .last-box{width: 1200px;margin: 0 auto;overflow: hidden;}

.first-box {
  position: relative;
  height: 75vh; /* 视口多高，它就多高 */
  min-height: 800px !important;
  min-width: 1500px !important;
  overflow: hidden;
  background: url("../assets/bg/bg2.png") no-repeat;
  background-size: cover;
  background-position: center center;
  background-color: #000;
  .first-title {
    color: #fff;
    // font-family: FontName;
    letter-spacing: 0.1em;
    // font-variation-settings: "opsz" auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-80%);
    span {
      font-size: 50px;
      font-weight: 500;
      line-height: 2;
    }
    p {
      font-size: 20px;
    }
  }
  .first-pictop {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #132155 0%, #233aa9 100%);
    overflow: hidden;
    .topCard-box{
        width: 1200px;
        display: flex;
        align-items: stretch;
        justify-content: center;
        .topCard {
            flex: 1;
          min-width: 190px;
          color: #fff;
          padding: 20px 10px;
          background: linear-gradient(90deg, #233aa9 0%, #132155 100%);
          :hover{
            transform: scale(1.1);
              }
    
          .topCardIcon {
                display: flex;
                align-items: center;
                padding-left: 10px;
                img {
                  height: 30px;
                  padding-right: 10px;
                }
            }
            .topCardText {
              font-size: 16px;
            }
        }
    }
    
  }
}
.second-box {
  color: #fff;
  font-size: 30px;
  padding-top: 80px;
  background-color: #000;
  img {
    width: 100%;
    min-width: 1200px;
    margin: 30px 0 100px;
  }
}
.third-box {
  color: #fff;
  background-color: #000;
  margin-bottom: 100px;
  .third-title {
    font-size: 30px;
    padding-top: 20px;
    padding-bottom: 50px;
  }
  .third-content{
    text-align: left;
    padding: 20px;
    background: url("../assets/bg/聚焦业务场景.png") no-repeat;
    background-size:cover;
    .content-top{
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        .top-icon{
            width: 50px;
            height: 50px;
            background: url("../assets/icons/样衣生命周期管理.png") center/contain no-repeat;
        }
        .top-title{
            font-size: 30px;
            padding: 15px 0;
            background: linear-gradient(270deg, #D1CEFF 0%, #FEFEFE 44%, #8478FF 103%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
        .content-text{font-size: 20px; }

    }
    .content-detail{
        .detail{ padding: 20px 0;}
        .detail-item{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-bottom: 10px;
            :hover{transform: scale(1.1);}
        }
        .content-text{font-size: 18px; }

        .content-text:hover{
            color: #0085ff;
        }

    }
       .detail-icon{
            width: 20px;
            height: 20px;
            padding-right: 20px;
            background: url("../assets/icons/勾选.png") center/contain no-repeat;
        }
        .detail-title{
            font-size: 20px;
            padding: 10px 0;
        }
        
    }

  }
.four-box{
    color: #fff;
    text-align: left;
    padding-bottom: 500px;
    background: url("../assets/bg/培训考试平台.png") no-repeat;
    background-size: contain;
    background-position: center center;


    margin-bottom: 100px;
    .four-top{
        margin-bottom: 50px;
        .top-icon{
            width: 50px;
            height: 50px;
            background: url("../assets/icons/培训考试平台.png") center/contain no-repeat;
        }
        // .top-title{font-size: 30px;padding-top: 20px;}
        .top-title{
            font-size: 30px;
            padding: 15px 0;
            background: linear-gradient(270deg, #D1CEFF 0%, #FEFEFE 88%, #8478FF 103%);
            // background: linear-gradient(270deg, #BED8FF 0%, #FEFEFE 88%, #2F50F3 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
        p{font-size: 20px;}

    }
    .four-content{
        display: flex;
        align-items: stretch;
        gap: 30px;
        .content-item{
            flex: 1;
            text-align: center;
            background-color: #000;
            background: url("../assets/bg/toBlue.png") no-repeat;
            background-size:cover;
            padding: 30px;
            padding-top: 50px;
            :hover{
                
                color:#fff ;
                transform: scale(1.1);
            }


            .item-icon{
                width: 50px;
                height: 50px;
                background: url("../assets/icons/培训考试平台.png") center/contain no-repeat;
            }
            .item-title{
                font-size: 24px;
            }
            p{
                text-align: left;
                font-size: 18px;

            }

        }

        
    }

}
.five-box{
    color: #fff;
    text-align: left;
    padding-bottom: 150px;

    background: url("../assets/bg/企业快递助手.png") no-repeat;
    background-size: 100% auto;
    // background-position: center center;
    .five-top{
        margin-bottom: 50px;
        .top-icon{
            width: 50px;
            height: 50px;
            background: url("../assets/icons/企业快递助手.png") center/contain no-repeat;
            
        }
        // .top-title{font-size: 30px;padding-top: 20px;}
        .top-title{
            font-size: 30px;
            padding: 15px 0;
            background: linear-gradient(270deg, #D1CEFF 0%, #FEFEFE 88%, #8478FF 103%);
            // background: linear-gradient(270deg, #BED8FF 0%, #FEFEFE 88%, #2F50F3 103%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
        p{font-size: 20px;}

    }
     .five-content{
            padding-right: 10px;
     }
    .content-item{
        display: flex;
        align-items: start;
        justify-content: center;
        gap: 10px;
        margin-bottom: 50px;
        :hover{
            color: #55b8fa !important;
        }
        .img{ padding: 10px;}
        .content-right{
            .content-title{font-size: 20px;}
            p{font-size: 18px;color: rgba(255, 255, 255, 0.7);}

        }

        ul{
            padding-left: 15px;
        }
        li{padding-bottom: 5px;font-size: 14px;color: rgba(255, 255, 255, 0.7);}
        li::marker {
            color: #3b5fe3;
        }

        
    }
    
}
.six-box {
  color: #fff;
  position: relative;
  padding: 50px 0 30px;
  overflow: hidden;
  background-color: #000;
  .six-container {
    min-width: 1200px;
    margin: 0 auto;
    .six-title {
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 80px;
      color: #fff;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    }
    .six-features {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin-bottom: 100px;
    .feature-item {
            text-align: left;
            padding: 40px 30px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 10px;
            transition: all 0.3s ease;
            border: 1px solid rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            &:nth-child(odd) {
                background: url("../assets/bg/toWhite.png") no-repeat;
                background-size: cover;
            }
            // 偶数（第 2、4、6... 个）
            &:nth-child(even) {
                background: url("../assets/bg/toBlack.png") no-repeat;
                background-size: cover;
            }
    
            h3 {
                font-size: 20px;
                font-weight: 500;
                margin-bottom: 15px;
                color: #fff;
            }
            p {
                font-family: Alibaba PuHuiTi 3;
                font-size: 18px;
                font-weight: 300;
                // line-height: 24px;
                color: rgba(255, 255, 255, 0.7);
            }
            .feature-icon {
                width: 70px;
                height: 70px;
                // background: rgba(255, 255, 255, 0.1);
                // border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 25px;
                transition: all 0.3s ease;
    
                img {
                    // width: 40px;
                    // height: 40px;
                    // object-fit: contain;
                }
            }
        }
      .feature-item:hover {
        color: #fff;
        transform: translateY(-10px);
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
        border-color: rgba(241, 239, 239, 0.2);
        background: linear-gradient(135deg,rgba(15, 15, 15, 0.95) 0%,rgba(2, 67, 163, 0.98) 100%);
        .feature-icon {
        //   background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }
        p {color: #fff;}
      }
    }
  }
}
.seven-box {
  background-color: #000;
  .seven-bottom {
    text-align: center;
    padding: 20px 0 100px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 15px;
    background: url("../assets/bg/突破增长瓶颈.png") no-repeat;
    background-size: 100% 100%;
    h3 {
      font-size: 30px;
      font-weight: 400;
      margin-bottom: 20px;
      color: #fff;
      line-height: 40px;
    }
    p {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 40px;
      line-height: 28px;
    }
  }
}


</style>
